
































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Buttonmenu from "@/components/shared/Buttonmenu.vue";
import Modal from "@/components/shared/Modal.vue";
import WeightsPath from "@/components/paths/Weights.vue";
import SimplePath from "@/components/paths/Simple.vue";
import MultiPath from "@/components/paths/Multi.vue";
import Roundtrip from "@/components/paths/Round.vue";
import CollectMushrooms from "@/components/paths/Collect.vue";
import TimedMushrooms from "@/components/paths/Timed.vue";

export enum GameType {
  WEIGHTSPATH = "WeightsPath",
  SIMPLEPATH = "SimplePath",
  MULTIPATH = "MultiPath",
  ROUNDTRIP = "Roundtrip",
  TIMEDMUSHROOMS = "TimedMushrooms",
  COLLECTMUSHROOMS = "CollectMushrooms",
}

@Component({
  components: {
    Buttonmenu,
    Modal,
    WeightsPath,
    MultiPath,
    SimplePath,
    Roundtrip,
    CollectMushrooms,
    TimedMushrooms,
  },
})
export default class Game extends Vue {
  @Prop({ required: true })
  type: GameType;
  @Prop({ type: Object, default: () => ({}) })
  args: {};

  resultText = "";
  isCorrect = [false, true];
  showResult = false;
  showAnimation = false;

  evaluatedGame(correct: boolean[]): void {
    if (correct[1]){
      if (correct[0]) {
        this.resultText = "Richtig!";
        this.isCorrect[0] = true;
      } else {
        this.resultText = "Falsch!";
        this.isCorrect[0] = false;
      }
      this.showResult = true;
      setTimeout(() => {
        this.showResult = false;
      }, 1500);
    }
  }

  get currentGameComponent() {
    return this.type;
  }
}
